import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import {
  WorkflowEnrollmentTimelineResponse,
  WorkflowActiveEnrollmentsResponse,
  WorkflowMonitoringDashboardResponse,
  WorkflowRecordHistoryResponse,
  WorkflowStepRetryResponse
} from '../models/workflow-monitoring.model';

@Injectable({ providedIn: 'root' })
export class WorkflowMonitoringApiService {
  private readonly base = `${environment.apiUrl}api`;

  constructor(private http: HttpClient) {}

  getEnrollmentTimeline(
    enrollmentId: number,
    params: { runType?: 'TEST' | 'PRODUCTION'; includeTestRuns?: boolean } = {}
  ): Observable<WorkflowEnrollmentTimelineResponse> {
    let p = new HttpParams();
    if (params.runType)                              p = p.set('runType', params.runType);
    if (params.includeTestRuns !== undefined)        p = p.set('includeTestRuns', String(params.includeTestRuns));
    return this.http.get<WorkflowEnrollmentTimelineResponse>(
      `${this.base}/workflow-enrollments/${enrollmentId}/timeline`, { params: p }
    );
  }

  getRecordWorkflowHistory(
    objectType: string,
    objectId: number,
    params: { status?: string; workflowId?: number; includeTestRuns?: boolean; includeSteps?: boolean } = {}
  ): Observable<WorkflowRecordHistoryResponse> {
    let p = new HttpParams();
    if (params.status)                              p = p.set('status', params.status);
    if (params.workflowId)                          p = p.set('workflowId', params.workflowId.toString());
    if (params.includeTestRuns !== undefined)        p = p.set('includeTestRuns', String(params.includeTestRuns));
    if (params.includeSteps !== undefined)           p = p.set('includeSteps', String(params.includeSteps));
    return this.http.get<WorkflowRecordHistoryResponse>(
      `${this.base}/workflow-records/${objectType}/${objectId}/workflow-history`, { params: p }
    );
  }

  getActiveEnrollments(
    workflowId: number,
    params: { includeTestRuns?: boolean } = {}
  ): Observable<WorkflowActiveEnrollmentsResponse> {
    let p = new HttpParams();
    if (params.includeTestRuns !== undefined) p = p.set('includeTestRuns', String(params.includeTestRuns));
    return this.http.get<WorkflowActiveEnrollmentsResponse>(
      `${this.base}/workflows/${workflowId}/active-enrollments`, { params: p }
    );
  }

  getMonitoringDashboard(
    workflowId: number,
    params: { rangeDays?: 30 | 60 | 90; includeTestRuns?: boolean } = {}
  ): Observable<WorkflowMonitoringDashboardResponse> {
    let p = new HttpParams();
    if (params.rangeDays)                           p = p.set('rangeDays', params.rangeDays.toString());
    if (params.includeTestRuns !== undefined)        p = p.set('includeTestRuns', String(params.includeTestRuns));
    return this.http.get<WorkflowMonitoringDashboardResponse>(
      `${this.base}/workflows/${workflowId}/monitoring-dashboard`, { params: p }
    );
  }

  retryExecutionStep(stepId: number, reason?: string): Observable<WorkflowStepRetryResponse> {
    return this.http.post<WorkflowStepRetryResponse>(
      `${this.base}/workflow-execution-steps/${stepId}/retry`,
      { reason: reason || undefined }
    );
  }
}
